module.exports = __webpack_public_path__ + "img/112.7766ece9.jpg";